"use client";

import { c as _c } from "react/compiler-runtime";
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import CheckboxSvg from 'src/components/svg/CheckboxSvg';
import { useState } from 'react';
import styles from "./NewsletterSignup.module.css";
import { locale } from "@locale";

//#region [Props]
type NewsletterSignupProps = {
  isStreaming: boolean;
};
//#endregion

//#region [Component]
export default function NewsletterSignup(t0) {
  const $ = _c(29);
  const {
    isStreaming
  } = t0;
  const [isChecked, setIsChecked] = useState(false);
  const [isFull, setIsFull] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <input className={styles.SEmailInput} type="email" placeholder={locale.newsletter.emailPlaceholder} required={true} name="EMAIL" id="mce-EMAIL" aria-labelledby="newsletterLabel" onChange={() => setIsFull(true)} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden="true" style={{
      position: "absolute",
      left: "-5000px"
    }}><input name="b_e0cead56b303960f1671cd15c_2ced82373a" tabIndex={-1} type="text" defaultValue="" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "none"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !isStreaming;
  let t5;
  if ($[3] !== t4) {
    t5 = <input type="checkbox" value="8" name="group[8][8]" id="mce-group[8]-8-0" checked={t4} readOnly={true} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isStreaming) {
    t6 = <input type="checkbox" value="16" name="group[8][16]" id="mce-group[8]-8-1" checked={isStreaming} readOnly={true} />;
    $[5] = isStreaming;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className="mc-field-group input-group" style={t3} aria-hidden="true">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = !isChecked;
  let t9;
  if ($[10] !== t8) {
    t9 = <button className={styles.SSubmitButton} id="mc-embedded-subscribe" name="subscribe" type="submit" disabled={t8}>Send</button>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t9) {
    t10 = <div><form className={styles.SForm} action="https://filmweb.us6.list-manage.com/subscribe/post?u=e0cead56b303960f1671cd15c&id=2ced82373a&f_id=00fbc2e1f0" method="post" name="mc-embedded-subscribe-form" noValidate={true} target="_blank">{t1}{t2}{t7}{t9}</form></div>;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] !== isChecked) {
    t11 = () => setIsChecked(!isChecked);
    t12 = <CheckboxSvg className={styles.SCheckboxSvg} isChecked={isChecked} />;
    $[15] = isChecked;
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={styles.SLabel}>Godta <FilmwebLink className={styles.SPersonvernLink} to="https://forms.filmweb.no/form/displayform?id=20" rel="noopener noreferrer" target="_blank">personvernerklæringen</FilmwebLink></div>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t11 || $[20] !== t12) {
    t14 = <div className={styles.SPersonvern} onClick={t11}>{t12}{t13}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== isChecked || $[23] !== isFull) {
    t15 = !isChecked && isFull && <div className={styles.SError}>Du må godta personvernerklæringen</div>;
    $[22] = isChecked;
    $[23] = isFull;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t10 || $[26] !== t14 || $[27] !== t15) {
    t16 = <div className={styles.SNewsletterSignup}>{t10}{t14}{t15}</div>;
    $[25] = t10;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}
const REGULAR_NEWSLETTER_ID = "565147c29b";
const STREAMING_NEWSLETTER_ID = "243fb0d50f";
//#endregion